/* File: formsApi.js
 * Path: ananunadm/src/api/formsApi.js
 *
 * Thin axios wrapper for the Forms & Surveys module, mirroring knowledgeApi.
 * Public calls use the shared API instance which strips the private-token for
 * /public/* paths automatically (see helpers/api.jsx).
 */
import API from "../helpers/api.jsx";

const base = "forms";

export const formsApi = {
	list: (params = {}) => API.get(base, { params }).then((r) => r.data),
	templates: () => API.get(`${base}/templates`).then((r) => r.data),
	active: () => API.get(`${base}/active`).then((r) => r.data),
	get: (id) => API.get(`${base}/${id}`).then((r) => r.data),
	create: (data) => API.post(base, data).then((r) => r.data),
	update: (id, data) => API.put(`${base}/${id}`, data).then((r) => r.data),
	remove: (id) => API.delete(`${base}/${id}`).then((r) => r.data),
	publish: (id) => API.post(`${base}/${id}/publish`, {}).then((r) => r.data),
	notify: (id) => API.post(`${base}/${id}/notify`, {}).then((r) => r.data),
	archive: (id) => API.post(`${base}/${id}/archive`, {}).then((r) => r.data),
	duplicate: (id) => API.post(`${base}/${id}/duplicate`, {}).then((r) => r.data),
	setStatus: (id, action) => API.post(`${base}/${id}/status/${action}`, {}).then((r) => r.data),

	responses: (id, params = {}) => API.get(`${base}/${id}/responses`, { params }).then((r) => r.data),
	response: (id, responseId) => API.get(`${base}/${id}/responses/${responseId}`).then((r) => r.data),
	deleteResponse: (id, responseId) => API.delete(`${base}/${id}/responses/${responseId}`).then((r) => r.data),
	analytics: (id, params = {}) => API.get(`${base}/${id}/analytics`, { params }).then((r) => r.data),
	exportCsvUrl: (id) => `${base}/${id}/export.csv`,
	exportCsv: (id) => API.get(`${base}/${id}/export.csv`, { responseType: "blob" }),

	// respondent (internal)
	answerForm: (id) => API.get(`${base}/answer/${id}`).then((r) => r.data),
	submitAnswer: (id, payload) => API.post(`${base}/answer/${id}`, payload).then((r) => r.data),

	// public (no auth)
	publicForm: (slug) => API.get(`public/${base}/${slug}`).then((r) => r.data),
	publicVerifyPassword: (slug, password) => API.post(`public/${base}/${slug}/verify-password`, { password }).then((r) => r.data),
	publicSubmit: (slug, payload) => API.post(`public/${base}/${slug}/answer`, payload).then((r) => r.data)
};

export default formsApi;
